export default {
  views: {
    invalidUrl: 'URL无效。',
    successToResetPassword: '密码已重置成功。',
    resetPassword: '重置密码',
    send: '发送',
    resetError: '密码重置链接已过期，或密码已被重置。',
    passwordRules: {
      title: '注意：密码规则',
      tips1: '请创建至少8位，包含字母与数字的密码。'
    },
    enrollOTP: {
      title: '注册双重认证',
      code: '验证码',
      verify: '验证'
    }
  }
};
